import { initAcServices } from "AC/helpers/admin-columns";
import { getMetricConfig } from "./utils/inline-var";
import CalculationCell from "./components/CalculationCell.svelte";
const AcServices = initAcServices();
const metricsConfig = getMetricConfig();
AcServices.addListener("Table.Ready", (e) => {
    const table = e.table;
    const tableElement = table.getElement();
    const tfoot = tableElement.querySelector('tfoot');
    const originalRow = tfoot.querySelector('tr');
    const clonedRow = originalRow.cloneNode(true);
    clonedRow.classList.add('acp-calculation-row');
    const cells = clonedRow.querySelectorAll('th, td');
    cells.forEach((cell, index) => {
        cell.innerHTML = ``;
    });
    table.Columns.getColumnNames().forEach((columnName, index) => {
        if (!metricsConfig.columns.includes(columnName)) {
            return;
        }
        const columnCell = clonedRow.querySelector('.column-' + columnName);
        if (!columnCell) {
            return;
        }
        new CalculationCell({
            target: columnCell,
            props: {
                column: columnName,
            }
        });
    });
    tfoot.appendChild(clonedRow);
});
